//更新版本为 以数字开头的点 
export default {
    version : "10.0.3.1",
    ownership : "北京力控元通科技有限公司"
}


// WEBPACK FOOTER //
// ./src/version.js